import { render, staticRenderFns } from "./ToolbarRunningApps.vue?vue&type=template&id=88240858&scoped=true&"
import script from "./ToolbarRunningApps.vue?vue&type=script&lang=js&"
export * from "./ToolbarRunningApps.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarRunningApps.vue?vue&type=style&index=0&id=88240858&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88240858",
  null
  
)

export default component.exports